import conversation from 'api/conversation/'
import ModalWrapper from 'components/ModalWrapper'
import Nixi1Spinner from 'components/Nixi1Spinner'
import React, { useEffect, useState } from 'react'
import Message from '../ChatChannelMessage'
import './styles.scss'

const ChatChannelThread = (props) => {
  const { isOpen, toggle, data, activitiesTypes } = props
  const [ chats, setChats ] = useState([])

  useEffect(() => {
    if (data?.user?.id) {
      conversation.conversations.getMessages({ userId: data.user.id, subjectId: data.subjectId, eventType: 'messages' }).then( result => {
        setChats(result?.data?.messages || [])
      })
    }
  }, [data])

  return (
    <ModalWrapper
      id={'modalMessageThread'}
      header={data?.user?.name}
      body={
        <div>
          <div className='section-options'>
          </div>
          <div className='section-body'>
            {
              chats?.length > 0
                ?
                chats.map((message, index) =>
                  (message.subjectId === data.subjectId && !activitiesTypes.includes(message.type)) ?
                    <Message
                      key={`${index}-${data.user.id}-${message.type}-${message.date}`}
                      user={data.user}
                      content={message}
                      isThread
                      activitiesTypes={activitiesTypes}
                    />
                    :
                    null
                )
                :
                <div className='containerSpinner' style={{ height: '100%' }}>
                  <Nixi1Spinner height='20vh' />
                </div>
            }
          </div>
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
    />
  )
}

export default ChatChannelThread
